import api from './api';

export const bannerApi = {
  // platform=app selects the shared app home inventory, including legacy appOnly records.
  // All web widths consume MOBILE; the historical PC bucket is unused.
  getBanners: async (locale = 'ko', signal) => {
    const response = await api.getPublic(
      `/banners?platform=app&locale=${locale === 'en' ? 'en' : 'ko'}`,
      {
        signal,
      },
    );
    return response.data.data;
  },

  trackClick: async (bannerId) => {
    await api.postPublic(`/banners/${bannerId}/click`);
  },
};
